import { useEffect, useState } from "react";
import clsx from "clsx";
import LogoutIcon from "../../../../assets/icons/logout.svg";
import Logo from "../../../../assets/icons/samtree-logo.png";
import SamWatchIcon from "../../../../assets/icons/watch_icon_1.png"
import SamThemeIcon from "../../../../assets/icons/samtheme-ico-rev.png"
import SamStudioIcon from "../../../../assets/icons/studio_icon_1.png"
import YamWatchIcon from "../../../../assets/icons/yam_icon.png"
import CouponRegister from "../../../../assets/icons/coupon-ico.png"
import { Link, useLocation } from "react-router-dom";
import "./index.css";
import { useNavigate } from "react-router-dom";
import {
  removeDataFromLocalStorage,
} from "../../../App/utils/util";

export const SideBar = (props: {
  collapsed: any;
  setCollapsed: (arg0: boolean) => void;
  fromCoupon: boolean;
}) => {
  const [name, setName] = useState("samwatch");
  const navigate = useNavigate();
  const location = useLocation()

  useEffect( () => {

    for (const route of location.pathname.split("/")) {
      switch( route ) {
        case "samwatch" : setName("samwatch"); break
        case "yamwatch" : setName("yamwatch"); break
        case "samtheme" : setName("samtheme"); break
        case "samstudio": setName("samstudio"); break
        case "coupon"   : setName("coupon"); break
      }
    } 
  }, [location])

  // 컬랩스가 디폴트로 설정되서 최대한 수정을 덜하기 위해 true로 기본 값을 함
  props.setCollapsed(true)
  return (
    <>
      <div className="fixed w-12 md:w-14 lg:w-14 xl:w-14 maxHeight bg-[#27324D] border-r-2 border-[#394564] z-10">
        <div className="h-full flex flex-col justify-between">
          <div className="control-group flex flex-col items-center">
              <button 
                className={clsx(
                  "m-1.5 p-1.5 md:p-2 md:m-2 justify-center rounded-xl hover:shadow-md focus:bg-sky-500 ",
                  name === "samwatch" ? "bg-sky-500" : "hover:bg-[#262E43]"
                )}
                onClick={ () => { navigate("/dashboard/samwatch")} }
              >
                <img style={{ width: "30px", height: "20px"}} src={SamWatchIcon} alt="" />
              </button>

              <button 
                className={clsx(
                  "m-1.5 p-1.5 md:p-2 md:m-2 justify-center rounded-xl hover:shadow-md focus:bg-sky-500 ",
                  name === "yamwatch" ? "bg-sky-500" : "hover:bg-[#262E43]"
                )}
                onClick={ () => { navigate("/dashboard/yamwatch")} }
              >
                <img style={{ width: "30px", height: "20px"}} src={YamWatchIcon} alt="" />
              </button>

              <button 
                className={clsx(
                  "m-1.5 p-1.5 md:p-2 md:m-2 justify-center rounded-xl hover:shadow-md focus:bg-sky-500 ",
                  name === "samtheme" ? "bg-sky-500" : "hover:bg-[#262E43]"
                )}
                onClick={ () => { navigate("/dashboard/samtheme"); }}
              >
                <img style={{ width: "30px", height: "20px"}} src={SamThemeIcon} alt="" />
              </button>

              <button 
                className={clsx(
                  "m-1.5 p-1.5 md:p-2 md:m-2 justify-center rounded-xl hover:shadow-md focus:bg-sky-500 ",
                  name === "samstudio" ? "bg-sky-500" : "hover:bg-[#262E43]"
                )}
                onClick={ () => { navigate("/dashboard/samstudio");  } }
              >
                <img style={{ width: "30px", height: "20px"}} src={SamStudioIcon} alt="" />
              </button>
            <div className="menu-icon-border">
            </div>
            <button 
              className={clsx(
                "m-1.5 p-1.5 md:p-2 md:m-2 justify-center rounded-xl hover:shadow-md focus:bg-sky-500 ",
                name === "coupon" ? "bg-sky-500" : "hover:bg-[#262E43]"
              )}
              onClick={ () => { navigate("/dashboard/coupon");  } }
            >
              <img style={{ width: "30px", height: "20px"}} src={CouponRegister} alt="" />
            </button>

          </div>
          <div className="settings-group flex flex-col items-center z-10">
            <hr className="w-full border-[#394564]"></hr>
            <Link
              onClick={() => {
                removeDataFromLocalStorage("login-auth-token");
                removeDataFromLocalStorage("isLoggedIn")
                removeDataFromLocalStorage("email")
                removeDataFromLocalStorage("refresh-token")
                navigate("/", { replace: true });
              }}
              to="/"
            >
              <img src={LogoutIcon} alt="" />
            </Link>
            <Link to="/">
              <img className="w-9" src={Logo} alt="" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
